import EmptySimple from './EmptySimple';

export default EmptySimple;
